export interface VideoItem {
  id: number;
  title: string;
  category: string;
  image: string;
  description: string;
  rating: number;
  year: number;
  region: string;
  status: string;
  episodes: number;
  director: string;
  actors: string[];
  type: string;
  duration: string;
  updateInfo: string;
  tags: string[];
}

export const categories = [
  { name: '热门推荐', slug: 'recommend', icon: 'ri-fire-line' },
  { name: '电视剧', slug: 'tv', icon: 'ri-tv-line' },
  { name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-emotion-laugh-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-ghost-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-lens-line' },
];

export const videos: VideoItem[] = [
  {
    id: 1,
    title: '长安十二时辰',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20scene%20with%20traditional%20architecture%20and%20costumes%2C%20cinematic%20lighting%2C%20Tang%20Dynasty%20style%2C%20warm%20atmospheric%20tones%2C%20professional%20film%20photography%20with%20soft%20shadows%20and%20clean%20composition&width=800&height=600&seq=video-tv-01&orientation=landscape',
    description: '唐朝天宝三年，长安城陷入了一场惊天阴谋。身陷囹圄的死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安城。这是一部扣人心弦的古装悬疑巨制，融合了历史、权谋与动作元素。',
    rating: 8.2,
    year: 2019,
    region: '中国大陆',
    status: '已完结',
    episodes: 48,
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    type: '古装悬疑',
    duration: '45分钟',
    updateInfo: '全48集已完结',
    tags: ['悬疑', '古装', '历史', '动作', '权谋'],
  },
  {
    id: 2,
    title: '流浪地球2',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20futuristic%20space%20station%20and%20earth%20in%20background%2C%20dramatic%20cinematic%20lighting%2C%20spaceship%20interior%2C%20grand%20scale%2C%20professional%20film%20photography%20with%20high%20contrast%20and%20deep%20shadows&width=800&height=600&seq=video-movie-01&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对宇宙之路的惊悚与危机，年轻人挺身而出，展开争分夺秒的生死之战。这是中国科幻电影的里程碑之作。',
    rating: 8.3,
    year: 2023,
    region: '中国大陆',
    status: '已上映',
    episodes: 1,
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    type: '科幻冒险',
    duration: '173分钟',
    updateInfo: '高清完整版',
    tags: ['科幻', '灾难', '冒险', '太空', '未来'],
  },
  {
    id: 3,
    title: '狂飙',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Crime%20drama%20series%20scene%20with%20police%20officer%20in%20modern%20Chinese%20city%2C%20noir%20lighting%2C%20tense%20atmosphere%2C%20urban%20night%20scene%2C%20professional%20film%20photography%20with%20dramatic%20shadows%20and%20clean%20composition&width=800&height=600&seq=video-tv-02&orientation=landscape',
    description: '一部横跨二十年的扫黑除恶群像剧。刑警安欣与黑恶势力高启强展开长达二十年的生死较量，展现了正义与邪恶的殊死搏斗，以及人性在极端环境下的复杂变化。',
    rating: 8.5,
    year: 2023,
    region: '中国大陆',
    status: '已完结',
    episodes: 39,
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    type: '刑侦犯罪',
    duration: '45分钟',
    updateInfo: '全39集已完结',
    tags: ['刑侦', '犯罪', '扫黑', '悬疑', '剧情'],
  },
  {
    id: 4,
    title: '满江红',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20film%20scene%20in%20ancient%20courtyard%20with%20soldiers%20in%20Song%20Dynasty%20armor%2C%20cinematic%20composition%2C%20mysterious%20atmosphere%2C%20dim%20lantern%20lighting%2C%20professional%20film%20photography%20with%20rich%20textures%20and%20dark%20tones&width=800&height=600&seq=video-movie-02&orientation=landscape',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一个小兵与亲兵营副统领意外被卷入了一场巨大的阴谋之中，层层反转，步步惊心。',
    rating: 7.9,
    year: 2023,
    region: '中国大陆',
    status: '已上映',
    episodes: 1,
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    type: '悬疑历史',
    duration: '159分钟',
    updateInfo: '高清完整版',
    tags: ['悬疑', '历史', '喜剧', '古装', '剧情'],
  },
  {
    id: 5,
    title: '乘风破浪的姐姐 第四季',
    category: 'variety',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20music%20variety%20show%20stage%20with%20spotlights%20and%20performers%2C%20vibrant%20concert%20lighting%2C%20entertainment%20show%20atmosphere%2C%20professional%20stage%20photography%20with%20dynamic%20colors%20and%20clean%20composition&width=800&height=600&seq=video-variety-01&orientation=landscape',
    description: '多位30+的姐姐们重新出发，通过唱跳比拼争夺成团席位。展现女性力量与无限可能，每一期都充满惊喜与感动，是年度最火爆的综艺节目之一。',
    rating: 8.0,
    year: 2023,
    region: '中国大陆',
    status: '热播中',
    episodes: 24,
    director: '芒果TV',
    actors: ['谢娜', '陈嘉桦', '刘逸云', '朱珠'],
    type: '音乐竞技',
    duration: '120分钟',
    updateInfo: '每周五更新',
    tags: ['综艺', '音乐', '竞技', '女性', '励志'],
  },
  {
    id: 6,
    title: '间谍过家家 第二季',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20family%20scene%20with%20spy%20themed%20characters%20in%20modern%20city%2C%20warm%20color%20palette%2C%20animated%20aesthetic%2C%20clean%20illustration%20style%20with%20soft%20lighting%20and%20charming%20composition&width=800&height=600&seq=video-anime-01&orientation=landscape',
    description: '为了执行维护世界和平的秘密任务，西国最强间谍「黄昏」组建了一个临时家庭。然而他的「女儿」是会读心的超能力者，「妻子」是暗杀者，三人互相隐瞒真实身份开始了共同生活。',
    rating: 9.1,
    year: 2023,
    region: '日本',
    status: '热播中',
    episodes: 25,
    director: '古桥一浩',
    actors: ['江口拓也', '种崎敦美', '早见沙织'],
    type: '喜剧动作',
    duration: '24分钟',
    updateInfo: '每周日更新',
    tags: ['动漫', '喜剧', '动作', '家庭', '间谍'],
  },
  {
    id: 7,
    title: '地球脉动 第三季',
    category: 'documentary',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20wildlife%20in%20savanna%20landscape%2C%20golden%20hour%20lighting%2C%20epic%20natural%20photography%2C%20professional%20wildlife%20cinematography%20with%20breathtaking%20composition%20and%20rich%20colors&width=800&height=600&seq=video-doc-01&orientation=landscape',
    description: 'BBC经典纪录片系列最新力作。从深海到沙漠，从极地到雨林，用最先进的拍摄技术捕捉地球上最壮观的自然奇观和动物行为，每一帧都是壁纸级别的画面。',
    rating: 9.8,
    year: 2023,
    region: '英国',
    status: '已完结',
    episodes: 8,
    director: 'BBC自然历史部',
    actors: ['大卫·爱登堡'],
    type: '自然纪录',
    duration: '60分钟',
    updateInfo: '全8集已完结',
    tags: ['纪录片', '自然', '动物', 'BBC', '地理'],
  },
  {
    id: 8,
    title: '三体',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20drama%20scene%20with%20mysterious%20cosmic%20elements%20and%20scientists%20in%20lab%2C%20cold%20color%20palette%2C%20mysterious%20atmosphere%2C%20professional%20film%20photography%20with%20scientific%20aesthetic%20and%20clean%20composition&width=800&height=600&seq=video-tv-03&orientation=landscape',
    description: '改编自刘慈欣同名科幻小说。纳米科学家汪淼被警官史强带入一个神秘组织，揭开了地球基础科学异常背后的真相，同时也发现了一个来自外星文明的巨大威胁。',
    rating: 8.0,
    year: 2023,
    region: '中国大陆',
    status: '已完结',
    episodes: 30,
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    type: '科幻悬疑',
    duration: '45分钟',
    updateInfo: '全30集已完结',
    tags: ['科幻', '悬疑', '刘慈欣', '剧情', '宇宙'],
  },
  {
    id: 9,
    title: '铃芽之旅',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20film%20scene%20with%20young%20girl%20in%20beautiful%20natural%20landscape%2C%20magical%20atmosphere%2C%20soft%20pastel%20colors%2C%20dreamy%20lighting%2C%20anime%20movie%20aesthetic%20with%20emotional%20composition&width=800&height=600&seq=video-movie-03&orientation=landscape',
    description: '生活在九州乡间的17岁少女铃芽，遇到了一位正在寻找"门"的神秘青年。追随着青年的脚步，铃芽来到了山上一片废墟之地，发现了一扇古老的门。',
    rating: 8.0,
    year: 2023,
    region: '日本',
    status: '已上映',
    episodes: 1,
    director: '新海诚',
    actors: ['原菜乃华', '松村北斗'],
    type: '动画奇幻',
    duration: '122分钟',
    updateInfo: '高清完整版',
    tags: ['动画', '奇幻', '冒险', '日本', '新海诚'],
  },
  {
    id: 10,
    title: '向往的生活 第七季',
    category: 'variety',
    image: 'https://readdy.ai/api/search-image?query=Rural%20Chinese%20countryside%20scene%20with%20traditional%20farmhouse%20and%20green%20fields%2C%20peaceful%20lifestyle%20atmosphere%2C%20warm%20natural%20lighting%2C%20professional%20photography%20with%20relaxed%20composition%20and%20soft%20shadows&width=800&height=600&seq=video-variety-02&orientation=landscape',
    description: '黄磊与何炅携手一群好友回归田园生活，在蘑菇屋里招待远道而来的客人，用美食与真诚传递生活的温度。在快节奏的现代生活中，感受慢下来的美好。',
    rating: 7.8,
    year: 2023,
    region: '中国大陆',
    status: '热播中',
    episodes: 14,
    director: '湖南卫视',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅'],
    type: '生活真人秀',
    duration: '90分钟',
    updateInfo: '每周六更新',
    tags: ['综艺', '生活', '美食', '慢生活', '真人秀'],
  },
  {
    id: 11,
    title: '进击的巨人 最终季',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20anime%20scene%20with%20giant%20titan%20and%20soldiers%20in%20epic%20battle%2C%20dramatic%20cinematic%20lighting%2C%20intense%20action%2C%20anime%20art%20style%20with%20powerful%20composition%20and%20deep%20shadows&width=800&height=600&seq=video-anime-02&orientation=landscape',
    description: '城墙外潜伏着吃人的巨人。艾伦·耶格尔亲眼目睹母亲被巨人吞噬，立誓要杀光所有巨人。随着故事深入，关于巨人和世界的真相逐渐浮出水面，震撼人心。',
    rating: 9.3,
    year: 2023,
    region: '日本',
    status: '已完结',
    episodes: 30,
    director: '林祐一郎',
    actors: ['梶裕贵', '石川由依', '井上麻里奈'],
    type: '黑暗奇幻',
    duration: '24分钟',
    updateInfo: '全30集已完结',
    tags: ['动漫', '黑暗', '奇幻', '战斗', '剧情'],
  },
  {
    id: 12,
    title: '蓝色星球 第二季',
    category: 'documentary',
    image: 'https://readdy.ai/api/search-image?query=Underwater%20ocean%20documentary%20scene%20with%20colorful%20coral%20reef%20and%20marine%20life%2C%20crystal%20clear%20water%2C%20vibrant%20underwater%20photography%2C%20professional%20nature%20cinematography%20with%20stunning%20depth%20and%20blue%20tones&width=800&height=600&seq=video-doc-02&orientation=landscape',
    description: '深入探索海洋世界的每一个角落。从极地冰川到热带珊瑚礁，从深海热泉到开阔大洋，展示了前所未见的海洋生物行为与壮丽景观。',
    rating: 9.7,
    year: 2017,
    region: '英国',
    status: '已完结',
    episodes: 7,
    director: 'BBC自然历史部',
    actors: ['大卫·爱登堡'],
    type: '自然纪录',
    duration: '60分钟',
    updateInfo: '全7集已完结',
    tags: ['纪录片', '海洋', '自然', 'BBC', '生物'],
  },
  {
    id: 13,
    title: '漫长的季节',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20drama%20set%20in%201990s%20industrial%20northeast%20China%2C%20autumn%20atmosphere%2C%20warm%20vintage%20tones%2C%20small%20town%20scene%2C%20professional%20film%20photography%20with%20melancholic%20composition&width=800&height=600&seq=video-tv-04&orientation=landscape',
    description: '一座北方小城，一个跨越二十年的故事。出租车司机王响意外卷入一桩陈年旧案，在追寻真相的过程中，揭开了一段尘封已久的往事与人性的复杂面向。',
    rating: 9.4,
    year: 2023,
    region: '中国大陆',
    status: '已完结',
    episodes: 12,
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊', '李庚希'],
    type: '悬疑剧情',
    duration: '60分钟',
    updateInfo: '全12集已完结',
    tags: ['悬疑', '剧情', '家庭', '年代', '犯罪'],
  },
  {
    id: 14,
    title: '消失的她',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20film%20scene%20in%20tropical%20resort%20at%20night%2C%20mysterious%20atmosphere%2C%20neon%20lights%2C%20dark%20beach%20setting%2C%20professional%20film%20photography%20with%20noir%20lighting%20and%20tense%20composition&width=800&height=600&seq=video-movie-04&orientation=landscape',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失。当何非苦寻无果时，一个陌生女人出现声称自己就是他的妻子。真相层层反转，结局出人意料。',
    rating: 7.5,
    year: 2023,
    region: '中国大陆',
    status: '已上映',
    episodes: 1,
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    type: '悬疑犯罪',
    duration: '122分钟',
    updateInfo: '高清完整版',
    tags: ['悬疑', '犯罪', '反转', '剧情', '推理'],
  },
  {
    id: 15,
    title: '咒术回战 第二季',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20action%20scene%20with%20supernatural%20powers%20and%20magical%20battle%2C%20dynamic%20composition%2C%20vibrant%20energy%20effects%2C%20urban%20setting%2C%20anime%20art%20style%20with%20intense%20action%20and%20striking%20visuals&width=800&height=600&seq=video-anime-03&orientation=landscape',
    description: '虎杖悠仁吞下了诅咒之王两面宿傩的手指后，踏上了咒术师之路。涩谷事变篇中，前所未有的危机降临，咒术界面临生死存亡的巨大挑战。',
    rating: 9.2,
    year: 2023,
    region: '日本',
    status: '热播中',
    episodes: 23,
    director: '御所园翔太',
    actors: ['榎木淳弥', '内田雄马', '濑户麻沙美'],
    type: '热血战斗',
    duration: '24分钟',
    updateInfo: '每周四更新',
    tags: ['动漫', '热血', '战斗', '超自然', '校园'],
  },
  {
    id: 16,
    title: '风味人间 第四季',
    category: 'documentary',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20atmosphere%2C%20culinary%20art%2C%20professional%20food%20photography%20with%20rich%20textures%20and%20appetizing%20composition&width=800&height=600&seq=video-doc-03&orientation=landscape',
    description: '跨越山海，探寻全球美食的根与魂。从中国乡村的烟火厨房到世界各地的美食秘境，用镜头记录人与食物之间最真挚的情感连接。',
    rating: 9.0,
    year: 2023,
    region: '中国大陆',
    status: '已完结',
    episodes: 8,
    director: '陈晓卿',
    actors: ['李立宏'],
    type: '美食纪录',
    duration: '50分钟',
    updateInfo: '全8集已完结',
    tags: ['纪录片', '美食', '人文', '旅行', '文化'],
  },
];

export const aboutData = {
  brandName: '青柠影视',
  slogan: '清新视界，随心所享',
  introduction: '青柠影视成立于2020年，是一家专注于提供高清在线影视内容的互联网平台。我们致力于为全球华语用户提供海量、优质、免费的影视资源，涵盖电视剧、电影、综艺、动漫、纪录片等多种类型。',
  mission: '让每一个人都能轻松享受高品质的影视内容，无需付费即可畅享高清画质与流畅播放体验。',
  vision: '成为全球华语用户首选的免费在线影视平台，以技术创新驱动观影体验的不断升级。',
  values: [
    { title: '用户至上', description: '始终将用户体验放在首位，持续优化播放流畅度与画质表现。' },
    { title: '内容为王', description: '精选海量优质影视资源，每日更新，满足多元化观影需求。' },
    { title: '技术驱动', description: '采用先进的视频压缩与传输技术，确保高清画质下的流畅播放。' },
    { title: '开放共享', description: '坚持免费模式，让优质影视内容触手可及，普惠每一位用户。' },
  ],
  stats: [
    { value: '5000万+', label: '月活跃用户' },
    { value: '10万+', label: '影视资源' },
    { value: '99.9%', label: '播放成功率' },
    { value: '4.8分', label: '用户满意度' },
  ],
  milestones: [
    { year: '2020年', event: '青柠影视正式上线，首批上线5000部影视内容' },
    { year: '2021年', event: '月活跃用户突破1000万，完成A轮融资' },
    { year: '2022年', event: '推出4K超高清专区，影视资源总量突破5万部' },
    { year: '2023年', event: '月活跃用户突破5000万，成为行业领先的免费影视平台' },
    { year: '2024年', event: '全面升级播放技术，推出AI智能推荐系统，用户满意度达4.8分' },
  ],
  contact: {
    email: 'contact@qingning.tv',
    wechat: '青柠影视官方',
    weibo: '@青柠影视',
    address: '北京市朝阳区望京科技园A座',
    phone: '400-888-6666',
  },
  faqs: [
    {
      question: '青柠影视真的完全免费吗？',
      answer: '是的，青柠影视始终坚持免费模式。您无需支付任何费用即可观看平台上所有影视内容。我们通过广告收入支持平台运营，确保用户可以持续享受免费的观影服务。',
    },
    {
      question: '为什么有时候播放会卡顿？',
      answer: '播放卡顿通常与您的网络环境有关。我们建议您检查网络连接，或尝试切换至较低清晰度。青柠影视采用了先进的CDN加速技术，在大多数网络环境下都能提供流畅的播放体验。',
    },
    {
      question: '支持哪些设备观看？',
      answer: '青柠影视支持PC浏览器、手机浏览器和平板设备。您只需通过浏览器访问我们的网站即可观看，无需下载任何软件或插件。我们推荐使用Chrome、Safari等主流浏览器以获得最佳体验。',
    },
    {
      question: '影视内容多久更新一次？',
      answer: '我们的内容团队每天都会更新资源库。热播剧集通常会在播出后24小时内上线，电影也会在院线下映后尽快上线。您可以在"最新上架"板块查看每日更新内容。',
    },
    {
      question: '如何反馈播放问题或内容建议？',
      answer: '您可以通过页面底部的"联系我们"信息，发送邮件至 contact@qingning.tv，或通过微信公众号、微博与我们联系。我们的客服团队会在24小时内回复您的反馈。',
    },
  ],
};